import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.nav, 'title'])
    }, [
      _createVNode(_component_Button, {
        btnName: "Back",
        btyType: "basic",
        title: "返回",
        onClick: _ctx.backFunc,
        style: _normalizeStyle({ marginLeft: _ctx.isBooking ? '0px' : '-40px' })
      }, null, 8, ["onClick", "style"]),
      _createElementVNode("h2", null, _toDisplayString(!_ctx.isMobile || !_ctx.isBooking ? _ctx.modalInfoSum.venueName : '') + " " + _toDisplayString(_ctx.isBooking ? _ctx.modalData.bookingInfo.courtName : ''), 1),
      _createVNode(_component_Button, {
        btnName: "Info",
        btyType: "basic",
        title: "場館資訊",
        class: _normalizeClass(_ctx.isInfoOpen && _ctx.$style.toggled),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInfo(!_ctx.isInfoOpen)))
      }, null, 8, ["class"]),
      _createVNode(_component_Button, {
        btnName: "Close",
        btyType: "close",
        title: "關閉",
        onClick: _ctx.closeModal
      }, null, 8, ["onClick"])
    ], 2),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.remark)
        }, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.modalInfoSum.sportName) + "．" + _toDisplayString(_ctx.modalInfoSum.cityName) + " " + _toDisplayString(_ctx.modalInfoSum.distName) + " ", 1),
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.modalData.data.date) + "．" + _toDisplayString(_ctx.modalData.subData.end
          ? `${_ctx.modalData.data.start}:00-${_ctx.modalData.subData.end}:00`
          : '--') + "．場租 " + _toDisplayString(_ctx.courtPrice ? _ctx.courtPrice : '--'), 1)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}